export const AUTH_TOKEN_KEY = "feathers-jwt";
export const AUTH_PROVIDER = "facebook";
export const FB_APP_ID = "140086573316440";



// WEBPACK FOOTER //
// ./src/constants/auth.constants.js